import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { constant } from 'app/app.constants';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { PostingService } from 'app/core/services/posting.service';
import { UploadsService } from 'app/pages/A2-utils/uploads.service';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-pre-posting',
  templateUrl: './pre-posting.component.html',
  styleUrls: ['./pre-posting.component.scss'],
})
export class PrePostingComponent implements OnInit, OnDestroy {
  @ViewChild('fileUpload') protected _fileUpload: ElementRef;
  @ViewChild('uploadBtnFccImport') protected _uploadBtnFccImport: ElementRef;
  private suscriptions: Subscription[] = [];
  protected fileName = '';
  protected uploadFile: any;

  constructor(
    private _loadingT2Service: T2LoadingService,
    protected _sweetAlertHelper: SweetAlertHelper,
    private _uploadService: UploadsService,
    private _postingService: PostingService
  ) {}

  ngOnInit() {}

  public bringFileSelector(): void {
    this._fileUpload.nativeElement.click();
  }
  public getProperties(event: {
    target: any;
    srcElement: { value: string; files: any };
  }): void {
    const MimeType = event.target.files[0].type;
    if (MimeType && !this.validMimeType(MimeType)) {
      this._sweetAlertHelper.captureException('The file type is invalid');
      return;
    } else {
      this.fileName = event.srcElement.value;
      this.uploadFile = event.srcElement.files;
    }
  }

  validMimeType(mimeType: string): boolean {
    const validMimeType = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ];
    return validMimeType.includes(mimeType);
  }

  public startUpload(): void {
    if (this.fileName) {
      this._loadingT2Service.show();
      this.suscriptions.push(
        this._uploadService
          .makeFileRequest(constant.URL_IMPORT_PRE_POSTING, [], this.uploadFile)
          .finally(() => this._loadingT2Service.hiden())
          .subscribe({
            next: () => {
              this._sweetAlertHelper.createCustomAlert({
                title: 'Success',
                text: 'You will receive a file with the information in your e-mail address.',
                type: 'success',
                timer: 3000,
                showConfirmButton: false,
              });
              this._loadingT2Service.hiden();
            },
            error: (error: any) => {
              this._sweetAlertHelper.captureException(error);
            },
          })
      );
    } else {
      this._sweetAlertHelper.createCustomAlert({
        title: 'Attention',
        type: 'info',
        text: 'Please, choose a file',
      });
    }
  }

  cancel() {
    this._postingService.reloadMainGrid(false);
  }

  ngOnDestroy(): void {
    if (this.suscriptions) {
      this.suscriptions.forEach((sub) => sub.unsubscribe());
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing-general/posting/pre-posting/pre-posting/pre-posting.component.ts